/** 将富文本/HTML 转为大屏跑马灯等场景可用的纯文本 */
export function stripHtml(input: string): string {
  if (!input) return ''
  return input
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
    .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<\/p>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(Number(code)))
    .replace(/\s+/g, ' ')
    .trim()
}

/** 轻量去标签（摘要/列表场景，不处理 HTML 实体） */
export function stripHtmlLite(input: string): string {
  if (!input) return ''
  return input
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

const EDITOR_MEDIA_TAG = /<(img|video|table|audio)\b/i

/** 富文本是否没有可见文字。图片、视频、表格、音频不算空白。 */
export function isBlankEditorHtml(input: string): boolean {
  if (EDITOR_MEDIA_TAG.test(input)) return false
  const text = input
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\u00a0/g, ' ')
    .trim()
  return text.length === 0
}

/** 离开确认比较用：空段落的不同写法视为同一份空白，不改提交内容。 */
export function stableEditorHtml(input: string): string {
  if (isBlankEditorHtml(input)) return ''
  return input
}
